import { QueryObserverBaseResult, useQuery } from "react-query";
import { queryKeys } from "../../query";
import api from "../../client";
import { RepresentativeDetailResponseData } from "../../types/representative";

export const getData = async (
  id: string | undefined,
): Promise<RepresentativeDetailResponseData> => {
  const { data } = await api.get<RepresentativeDetailResponseData>(
    `/representatives/${id}`,
  );

  return data;
};

export const useRepresentative = (
  id: string | undefined,
): QueryObserverBaseResult<RepresentativeDetailResponseData> => {
  const { data, ...props } = useQuery(
    queryKeys.representative(id),
    () => getData(id),
    { enabled: Boolean(id) },
  );
  return { data, ...props };
};
